module.exports = __webpack_public_path__ + "static/media/SH 23.e4e3e850.mp3";